import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=06696b54&scoped=true&"
import script from "./CheckoutForm.vue?vue&type=script&lang=js&"
export * from "./CheckoutForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutForm.vue?vue&type=style&index=0&id=06696b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06696b54",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormInvalidFeedback, BInputGroup, BAlert, BSpinner, BForm, BModal, BFormSelect, BFormGroup, BCol, BRow, BCard, BFormRadioGroup, BCardText, BInputGroupPrepend, BFormCheckbox, BToast, BPopover, BContainer} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormInvalidFeedback, BInputGroup, BAlert, BSpinner, BForm, BModal, BFormSelect, BFormGroup, BCol, BRow, BCard, BFormRadioGroup, BCardText, BInputGroupPrepend, BFormCheckbox, BToast, BPopover, BContainer})
    


    import installDirectives from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBModal} from 'bootstrap-vue'
    installDirectives(component, {'b-modal': VBModal})
    

export default component.exports